import React from 'react';

/**
 * Render html
 * @param description
 * @returns {React.JSX.Element}
 */
const RenderHtml = ({description}: {description: string}) => <div dangerouslySetInnerHTML={{__html: description}} />;
export default RenderHtml;
